// Globals
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuProps } from 'antd';

// Store
import { useAppState } from '@/store';

// Components
import {
  StyledLink,
  StyledMainTitleWrapper,
  StyledPageTitle,
  StyledPageWrapper,
  StyledTitleAndLinkWrapper,
} from '../../components/Styled';
import { Menu } from '@/ui';
import { categoriesSelector } from '@/modules/Categories';

// Models
import { ROUTES } from '@/models/router.model';

// Helpers
import { CategoryDetailsTabs, getCategoryDetailsTabsConfig } from '../../helpers/configs';

const CategoryDetailsContainer = () => {
  const { t } = useTranslation(['categories']);
  const { categoryDetails } = useAppState(categoriesSelector);

  const categoryDetailsTabsConfig = useMemo(() => getCategoryDetailsTabsConfig(t), []);
  const [selectedKey, setSelectedKey] = useState(categoryDetailsTabsConfig[0].key);
  const selectedCategoriesTab = useMemo(
    () => categoryDetailsTabsConfig.find((item) => item.key === selectedKey),
    [selectedKey],
  );

  const onClick: MenuProps['onClick'] = (e) => {
    setSelectedKey(e.key as CategoryDetailsTabs);
  };

  return (
    <StyledPageWrapper>
      <StyledMainTitleWrapper>
        <StyledTitleAndLinkWrapper>
          <StyledLink to={ROUTES.CATEGORIES}>{t('back_to_all_categories')}</StyledLink>
          <StyledPageTitle>
            {t('category')} {categoryDetails?.name}
          </StyledPageTitle>
        </StyledTitleAndLinkWrapper>
        <Menu
          mode="horizontal"
          items={categoryDetailsTabsConfig}
          defaultSelectedKeys={[selectedKey]}
          onClick={onClick}
        />
      </StyledMainTitleWrapper>

      {selectedCategoriesTab!.content}
    </StyledPageWrapper>
  );
};

export default CategoryDetailsContainer;
